<template>
    <ul :qa="`ath-big-number-list`">
        <li v-for="(item, index) in items" :key="index" class="ath-big-number-list-item" :qa="`ath-big-number-list-item-${index}`">
            <div class="f sp-xs item-frame">
                <div class="ath-big-number-list-number te-hero-fat" :class="[`c-${colorStyle}`]">{{
                    index + 1 }}</div>
                <div class="fg">
                    <div :qa="`ath-big-number-list-item-content-${index}`">
                        <slot :item="item" :number="index + 1"></slot>
                    </div>
                </div>
            </div>
        </li>
    </ul>
</template>

<script>


export default {
    name: 'mead-big-number-list',
    props: {
        /**
         * The list of items to render, each displayed alongside its rank number
         * via the default scoped slot (item, number).
         */
        items: { type: Array, default: () => [] },
        /**
         * Color class applied to the rank number of each item, e.g. one of the
         * COLOR_CLASSES sentiment styles.
         */
        colorStyle: { type: String, default: () => MeadCommon.COLOR_CLASSES.SENTIMENT_POSITIVE },
    },
    computed: {

    }
};
</script>

<style lang="scss" scoped>
.ath-big-number-list-number {
    padding: 1rem 0;
    line-height: 5rem;
}
</style>
